import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const AboutIntro = () => {
  const { lang } = useLanguage();
  const isSpanish = lang === 'es';
  const imageUrl = 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/ded59f4bc1a1e49e6e28e873c79b4f37.jpg';

  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-28">
      <motion.div
        initial={{ opacity: 0, x: -24 }}
        animate={{ opacity: 1, x: 0 }}
        className="relative"
      >
        <div className="absolute -inset-5 bg-orange-500/15 blur-3xl rounded-full" />
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2.5rem] border border-white/10 bg-zinc-900 shadow-2xl">
          <img
            src={imageUrl}
            alt={
              isSpanish
                ? 'Mathias Deppe, consultor de crecimiento digital cerca de Barcelona'
                : 'Mathias Deppe, digital growth consultant based near Barcelona'
            }
            className="w-full h-full object-cover grayscale transition duration-700 hover:scale-105 hover:grayscale-0"
          />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 24 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <p className="text-orange-500 font-black text-xs tracking-[0.24em] uppercase mb-5">
          About Mathias Deppe
        </p>
        <h1 className="text-4xl md:text-6xl font-black tracking-tighter text-white leading-[0.92] mb-8">
          {isSpanish
            ? 'Los negocios no necesitan más contenido.'
            : 'Businesses do not need more content.'}
          <span className="block text-orange-500 mt-2">
            {isSpanish
              ? 'Necesitan una mejor forma de convertir la atención en clientes.'
              : 'They need a better way to turn attention into customers.'}
          </span>
        </h1>

        <div className="space-y-5 text-zinc-400 text-lg leading-relaxed">
          <p>
            {isSpanish
              ? 'Soy Mathias Deppe, consultor de crecimiento digital cerca de Barcelona. Ayudo a negocios locales a convertir lo que ya saben en mensajes más claros, mejor contenido y sistemas sencillos de adquisición de clientes.'
              : 'I am Mathias Deppe, a digital growth consultant based near Barcelona. I help local businesses turn what they already know into clearer messaging, better content and simple customer acquisition systems.'}
          </p>
          <p>
            {isSpanish
              ? 'Pero mi experiencia no viene del marketing tradicional. Pasé 10 años en ventas B2B.'
              : 'But my background is not in traditional marketing. I spent 10 years in B2B sales.'}
          </p>
          <p className="text-white font-bold text-xl">
            {isSpanish
              ? 'El buen marketing empieza por entender por qué compra la gente.'
              : 'Good marketing starts with understanding why people buy.'}
          </p>
          <p>
            {isSpanish
              ? 'Hoy combino esa experiencia comercial con producción de contenido, diseño instruccional y automatización impulsada por IA para ayudar a los negocios a construir un recorrido de cliente que realmente tenga sentido.'
              : 'Today, I combine that sales experience with content production, instructional design and AI-powered automation to help businesses build a customer journey that actually makes sense.'}
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default AboutIntro;